/**
 * leadPhoneStore.js — móvil del LEAD al que el simulador de autoescuelas manda los avisos REALES
 * («Notificar de forma individual» y «Enviar semana», vía /ventas/simulator-send-practica-semana).
 * Se recuerda durante la sesión del navegador (sessionStorage; si no hay, solo en memoria).
 * Siempre en E.164 (+prefijo y dígitos): es lo que valida el lambda.
 */
import countries from "../../data/countries.json";

const KEY = "sim_autoescuela_lead_phone";
let memory = null;

const digitsOf = (s) => String(s || "").replace(/\D/g, "");

/** Mismo criterio que «Simular clase» y CrearAcceso: entre 6 y 14 dígitos. */
export function isValidLeadDigits(digits) {
  const d = String(digits || "").replace(/^0+/, "");
  return d.length >= 6 && d.length <= 14;
}

/** Une prefijo («+34») y número tecleado → E.164, o "" si no es válido. */
export function buildLeadPhone(prefix, raw) {
  const d = digitsOf(raw).replace(/^0+/, "");
  if (!isValidLeadDigits(d)) return "";
  return `${prefix || "+34"}${d}`;
}

/** Normaliza un teléfono cualquiera del contexto (con o sin «+», «00», móvil español pelado) → E.164 o "". */
export function normalizeLeadPhone(raw) {
  let s = String(raw || "").trim().replace(/[\s\-().]/g, "");
  if (!s) return "";
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  if (!s.startsWith("+") && /^[67]\d{8}$/.test(s)) s = `+34${s}`;
  return /^\+[1-9]\d{7,14}$/.test(s) ? s : "";
}

/** Separa un E.164 en { prefix, number } para rellenar el selector (prefijo más largo que coincida). */
export function splitLeadPhone(e164) {
  const p = normalizeLeadPhone(e164);
  if (!p) return { prefix: "+34", number: "" };
  const dial = countries
    .map((c) => c.dial_code)
    .filter((d) => p.startsWith(d))
    .sort((a, b) => b.length - a.length)[0];
  return dial ? { prefix: dial, number: p.slice(dial.length) } : { prefix: "+34", number: p.replace(/^\+/, "") };
}

export function getLeadPhone() {
  if (memory) return memory;
  try {
    const v = normalizeLeadPhone(window.sessionStorage.getItem(KEY));
    if (v) memory = v;
  } catch (_) { /* sin sessionStorage: solo memoria */ }
  return memory || "";
}

export function setLeadPhone(e164) {
  memory = normalizeLeadPhone(e164) || null;
  try {
    if (memory) window.sessionStorage.setItem(KEY, memory);
    else window.sessionStorage.removeItem(KEY);
  } catch (_) { /* idem */ }
}

/** Últimos 4 dígitos para enseñar el destino sin volcar el número entero en el toast. */
export function maskLeadPhone(e164) {
  const p = normalizeLeadPhone(e164);
  return p ? `…${p.slice(-4)}` : "";
}
